var __assign = this && this.__assign || function () {
  __assign = Object.assign || function (t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];
      for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
    }
    return t;
  };
  return __assign.apply(this, arguments);
};
var __rest = this && this.__rest || function (s, e) {
  var t = {};
  for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
  if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
    if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
  }
  return t;
};
import React from 'react';
import { Box } from 'pcln-design-system';
import OptInForm from '../OptInForm';
/** @public */
var OptInBody = function (_a) {
  var _b = _a.backgroundColor,
    backgroundColor = _b === void 0 ? 'background.lightest' : _b,
    _c = _a.buttonText,
    buttonText = _c === void 0 ? 'Send me deals' : _c,
    children = _a.children,
    _d = _a.emailInputAriaLabel,
    emailInputAriaLabel = _d === void 0 ? 'Promotion email input' : _d,
    _e = _a.placeholder,
    placeholder = _e === void 0 ? 'example@address.com' : _e,
    success = _a.success,
    successTemplate = _a.successTemplate,
    props = __rest(_a, ["backgroundColor", "buttonText", "children", "emailInputAriaLabel", "placeholder", "success", "successTemplate"]);
  return React.createElement(Box, {
    color: backgroundColor,
    width: 1
  }, successTemplate && success ? successTemplate : React.createElement(OptInForm, __assign({
    buttonText: buttonText,
    emailInputAriaLabel: emailInputAriaLabel,
    placeholder: placeholder
  }, props), children));
};
export default OptInBody;